


















import { Component, Vue, Prop } from "vue-property-decorator";
import { Task, ScheduledTask, isScheduledTask } from "@/data/models/Task";
import TaskSchedulingInfoItemComponent from "@/components/scheduling/TaskSchedulingInfoItemComponent.vue";
import { SchedulingModule } from "@/store/modules/SchedulingModule";
import { formatDateWithWeekday, formatJsTime } from "@/utils/DateFormatter";
import {
  getDateFromYearMonthDateString,
  getDateFromHoursAndMinuteString,
} from "@/utils/DateHelper";

export enum TaskSchedulingInfoItemColor {
  WHITE,
  GREEN,
  YELLOW,
  RED,
}

export interface TaskSchedulingInfoItem {
  text: string;
  color: TaskSchedulingInfoItemColor;
}

@Component({
  components: {
    "info-item": TaskSchedulingInfoItemComponent,
  },
})
export default class TaskSchedulingInfoComponent extends Vue {
  @Prop()
  task!: Task | ScheduledTask;

  get date(): TaskSchedulingInfoItem | null {
    if (isScheduledTask(this.task)) {
      return {
        text: formatDateWithWeekday(this.task.startDate),
        color: this.task.wasConfirmed
          ? TaskSchedulingInfoItemColor.GREEN
          : TaskSchedulingInfoItemColor.RED,
      };
    } else {
      const { targetDate, isTargetDateFixed } = this.task.planningParameters;

      const date = getDateFromYearMonthDateString(targetDate);

      if (date) {
        return {
          text: formatDateWithWeekday(date),
          color: isTargetDateFixed
            ? TaskSchedulingInfoItemColor.YELLOW
            : TaskSchedulingInfoItemColor.WHITE,
        };
      }
    }

    return null;
  }

  get time(): TaskSchedulingInfoItem | null {
    if (isScheduledTask(this.task)) {
      return {
        text: formatJsTime(this.task.startDate),
        color: this.task.wasConfirmed
          ? TaskSchedulingInfoItemColor.GREEN
          : TaskSchedulingInfoItemColor.RED,
      };
    } else {
      const { targetTime, isTargetTimeFixed } = this.task.planningParameters;

      const date = getDateFromHoursAndMinuteString(targetTime);

      if (date) {
        return {
          text: formatJsTime(date),
          color: isTargetTimeFixed
            ? TaskSchedulingInfoItemColor.YELLOW
            : TaskSchedulingInfoItemColor.WHITE,
        };
      }
    }

    return null;
  }

  get user(): TaskSchedulingInfoItem | null {
    if (isScheduledTask(this.task)) {
      const nickname = SchedulingModule.userLookup.getUser(this.task.userId)
        ?.nickname;

      if (!nickname) {
        return null;
      }

      return {
        text: nickname,
        color: this.task.wasConfirmed
          ? TaskSchedulingInfoItemColor.GREEN
          : TaskSchedulingInfoItemColor.RED,
      };
    } else {
      const { targetUserId, isTargetUserFixed } = this.task.planningParameters;

      if (targetUserId) {
        const nickname = SchedulingModule.userLookup.getUser(targetUserId)
          ?.nickname;

        if (nickname) {
          return {
            text: nickname,
            color: isTargetUserFixed
              ? TaskSchedulingInfoItemColor.YELLOW
              : TaskSchedulingInfoItemColor.WHITE,
          };
        }
      }
    }

    return null;
  }
}
